<style rel="stylesheet/scss" lang="scss" scoped="scoped">
.newsContent {
  margin: 100px auto 60px;
  width: 1200px;

  .newsleft {
    width: 310px;
    margin-left: 40px;

    .titleimg {
      height: 51px;
      margin-bottom: 26px;
    }

    .title {
      font-size: 42px;
      color: #1b1b1b;
      padding-bottom: 30px;
      border-bottom: 1px solid #1b90ef;
    }
  }

  .newsContainer {
    margin-left: 100px;
    .block {
      text-align: center;
    }
    .newstext {
      margin-bottom: 40px;

      .textbox {
        .newscontentbox {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;

          .title {
            margin: 5px 0 10px;
            line-height: 30px;
          }

          .lead {
            margin-bottom: 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }

        .textBac {
          margin-right: 30px;
          flex-shrink: 0;
          height: 217px;
          width: 328px;
          background-size: cover;
        }
      }
    }
  }
}

.leftheader {
  width: 100%;
  color: #666;

  >ul {
    width: 100%;

    >li {
      width: 100%;
      cursor: pointer; // float: left;
      text-align: center;
      line-height: 60px;
      color: #000;
      letter-spacing: 3px;
      font-size: 16px;

      .itemCemter {
        display: flex;
        align-items: center;

        .ml6 {
          margin-left: 6px;
        }

        .greyline {
          background: #000;
          display: inline-block;
          height: 1px;
          width: 6px;
          margin: 0 40px;
        }

        .activeline {
          background: #1b90ef;
          display: inline-block;
          height: 1px;
          width: 6px;
          margin: 0 40px;
        }
      }

      &:hover {
        color: #1b90ef;
      }

      >ul {
        width: 100%;
        background: #fff;

        li {
          &:hover {
            color: #1b90ef;
          }
        }
      }
    }

    .active {
      color: #1b90ef;
    }
  }
}
</style>
<template>
  <div class="newsBox">
    <Head :selectindex="selectindex"></Head>
    <div class="contentflex">
      <div class="newsContent flex">
        <div class="newsleft">
          <img class="titleimg" src='../assets/images/Information.png' />
          <div class="title">新闻及公告</div>
          <div class="leftheader">
            <ul>
              <li :class="[{ active: item.show }]" @click="changeli(index, item)" v-for="(item, index) in headerData">
                <div class="itemCemter"> <span :class="item.show ? 'activeline' : 'greyline'"></span>{{ item.name }}<span
                    class="ml6">[{{ item.num }}]</span></div>
                <ul v-show="item.show">
                  <li v-for="(a, index) in item.list">{{ a }}</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="container newsContainer">
          <div>
            <div class="newstext" v-for="(item, index) in newData" :key="index">
              <div @click="goDetail(item)" :class="(item.content) ? 'textbox flex cursor' : 'textbox flex'">
                <div :class="'textBac' + index" class='textBac'
                  :style="{ backgroundImage: 'url(' + item.imgUrl + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center' }">
                </div>
                <div class="newscontentbox">
                  <div>
                    <div class="color999 font16">
                      {{ title }} | {{ timetrans(item.createDate) }}
                    </div>
                    <h3 class="font24 title">{{ item.title }}</h3>
                    <p class="font16 lead">{{ item.summary }}</p>
                  </div>
                  <div class="color999 font16">点击阅读 ></div>
                </div>
              </div>
            </div>
            <div class="block">
              <el-pagination background layout="total,prev, pager, next" v-model="page" @current-change="handleCurrentChange"
                :current-page="page" :page-size="5" :total="total" :hide-on-single-page="true"  >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <footer-content></footer-content>
    </div>

  </div>
</template>

<script>
import Head from '../components/headercontent'
import Service from '../common/service'
import footerContent from '../components/footercontent'
import dayjs from 'dayjs'
export default {
  name: "news",
  data() {
    return {
      title: '新闻',
      typeId: '',
      selectindex: 3,
      headerData: [{
        name: '全部新闻',
        list: [],
        show: true,
        num: 0

      }],
      page: 1,
      size: 5,
      total: 0,
      newData: []
    }
  },
  created() {
    document.getElementsByTagName("title")[0].innerHTML = "公司新闻";
    this.getnewstype()
    this.getNews();
  },
  mounted() {
    $('html , body').animate({
      scrollTop: 0
    }, 'slow');
  },
  methods: {
    changeli(ind, item) {
      // 先循环数据中的show将其全部置为false,此时模板里的v-if判断生效关闭全部二级菜单,并移除样式
      this.headerData.forEach(i => {
        // 判断如果数据中的headerData[i]的show属性不等于当前数据的show属性那么headerData[i]等于false
        if (i.show !== this.headerData[ind].show) {
          i.show = false;
        };

      });
      item.show = !item.show;
      this.title = item.name;
      this.page = 1;
      this.total = item.num;
      if (this.typeId == item.id) {
        item.show = true;
      } else {
        this.typeId = item.id;
        this.getNews()
      }
    },

      handleCurrentChange(val) {
        this.page = val;
        this.getNews();
      },

    goDetail(item) {
      if (item.content) {
        let routeData = this.$router.resolve({
          name: "newsDetail",
          query: {
            index: this.$route.query.index,
            id: item.id
          }
        });
        window.open(routeData.href, '_blank');
      }
      // this.$router.push({path:'/healthDetail',query:{index:this.$route.query.index,id: id}})
    },
    timetrans(timestamp) {
      return dayjs(timestamp).format('YYYY年MM月DD日')
    },
    getnewstype() {
      Service.news().getnewstype({}).then(response => {
        var data = response.data;
        let sumNum = 0;
        for (let item of data) {
          var obj = {
            name: item.name,
            show: false,
            id: item.id,
            num: item.newsCount
          }
          sumNum += item.newsCount;
          this.headerData.push(obj)
        }
        this.total = this.headerData[0].num = sumNum;
      }, err => {
        console.log(err);
      });
    },
    getNews() {
      Service.news().postnews({
        page: this.page,
        size: this.size,
        typeId: this.typeId
      }).then(response => {
        this.newData = response.data.records;
        this.total = response.data.total;
      }, err => {
        console.log(err);
       });
    },

  },
  components: {
    Head,
    footerContent
  },

}
</script>


// WEBPACK FOOTER //
// src/views/news.vue